import { Box, Link, Typography } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import { publicColors, publicContainerSx, publicFontFamily } from './publicTheme';

const headingSx = {
    fontFamily: publicFontFamily,
    fontWeight: 700,
    fontSize: { xs: '1.15rem', md: '1.25rem' },
    color: publicColors.ink,
    mt: 4,
    mb: 1.5,
};

const paragraphSx = {
    fontFamily: publicFontFamily,
    color: publicColors.inkMuted,
    fontSize: '1rem',
    lineHeight: 1.75,
    mb: 2,
};

const listSx = {
    fontFamily: publicFontFamily,
    color: publicColors.inkMuted,
    fontSize: '1rem',
    lineHeight: 1.75,
    pl: 3,
    mb: 2,
};

function LegalDocumentLayout({ title, lastUpdated, children }) {
    return (
        <Box className="public-site" sx={{ bgcolor: '#fff', minHeight: '100vh' }}>
            <Header />
            <Box component="main" sx={{ py: { xs: 5, md: 7 }, px: 2 }}>
                <Box sx={publicContainerSx}>
                    <Typography
                        component="h1"
                        sx={{
                            fontFamily: publicFontFamily,
                            fontWeight: 800,
                            fontSize: { xs: '1.75rem', md: '2.25rem' },
                            color: publicColors.ink,
                            letterSpacing: '-0.02em',
                            mb: 1,
                        }}
                    >
                        {title}
                    </Typography>
                    {lastUpdated && (
                        <Typography variant="body2" sx={{ color: publicColors.inkSoft, mb: 4 }}>
                            Última atualização: {lastUpdated}
                        </Typography>
                    )}
                    <Box sx={{ maxWidth: 800 }}>
                        {children}
                    </Box>
                    <Box sx={{ mt: 5, pt: 3, borderTop: `1px solid ${publicColors.border}` }}>
                        <Link component={RouterLink} to="/" sx={{ fontWeight: 600 }}>
                            ← Voltar ao início
                        </Link>
                    </Box>
                </Box>
            </Box>
            <Footer />
        </Box>
    );
}

export { headingSx, paragraphSx, listSx };
export default LegalDocumentLayout;
